module.exports = __webpack_public_path__ + "img/vip.0bdb74ba.png";